import http from 'plugins/axios';

export default {
  getWithdrawList(data) {
    return http.get({
      url: '/la/admin/withdraw/limit/switch',
      data
    });
  },
  deleteWithdrawLimit({ userId }) {
    return http.post({
      url: '/la/admin/delete/withdraw/limit?userId=' + userId,
    });
  }
};
